import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

let busy = false;

async function addLines(ids, source) {
  const deferred = CartLinesUpdateEvent.createPromise();
  busy = true;
  source.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: ids.map((id) => ({ merchandiseId: String(id), quantity: 1 })),
      promise: deferred.promise,
    })
  );
  busy = false;
  try {
    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((c) => c.dataset.sectionId)
      .filter(Boolean);
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })), sections: sectionIds.join(',') }),
    }).then((r) => r.json());
    const cart = await fetch(Theme.routes.cart_url + '.js').then((r) => r.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, source: 'hanaya-addons', sections: res.sections, didError: !!res.status, itemCount: ids.length },
    });
    return !res.status;
  } catch (error) {
    deferred.reject(error);
    return false;
  }
}

// Product page: chocolates ticked are added right after the bouquet.
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (busy || event.action !== 'add') return;
  const form = event.target instanceof Element ? event.target.closest('product-form-component') : null;
  if (!form) return;
  const checks = [...document.querySelectorAll('[data-h-addon-check]:checked')];
  if (!checks.length) return;
  event.promise?.then(({ detail }) => {
    if (detail?.didError) return;
    addLines(checks.map((c) => c.value), form).then((ok) => {
      if (ok) checks.forEach((c) => (c.checked = false));
    });
  });
});

// Cart drawer: one-tap "Add" buttons.
document.addEventListener('click', async (event) => {
  const button = event.target instanceof Element ? event.target.closest('[data-h-addon]') : null;
  if (!button) return;
  event.preventDefault();
  const label = button.textContent;
  button.disabled = true;
  button.textContent = '…';
  const ok = await addLines([button.dataset.hAddon], button);
  if (!ok) {
    button.disabled = false;
    button.textContent = label;
  }
});
